<template>
    <flex-element
        class-default-inline="f-relative f-min-h-4 f-min-w-4 mob:fu-tab-dock-location-left tab:fu-tab-dock-location-left lap:fu-tab-dock-location-left des:fu-tab-dock-location-left"
    >
        <collection-controls
            v-show="isSelected"
            location="location-hero-tabs"
            position="position-hero-tabs"
            :visible-index="currentTabIndex"
            :num-elements="tabCount()"
            @add="addTab"
            @delete="removeTab"
            @previous="previousTab"
            @next="nextTab"
            @increment="incrementTab"
            @decrement="decrementTab"
        />
        <div
            :class="`f-relative ${!hasMobileTransition ? 'f-flex' : 'f-flex mob:f-hidden tab:f-hidden'} component__div f-h-1/1`"
        >
            <o-container
                ref="tabs"
                v-bind="element(1)"
                style="-webkit-overflow-scrolling: touch"
                class-default="f-flex tabs__section f-items-center f-bg-transparent f-min-h-4 f-min-w-4"
                display-name="Tabs Container"
                @element-updated="elementUpdated"
            >
                <template v-slot="{ elementUpdated, elementsNew }">
                    <tab-container
                        v-for="(element, index) in elementsNew"
                        :key="element.id"
                        v-group:tab-button
                        class-default="f-block f-z-1 f-items-center f-flex-grow f-bg-transparent f-cursor-pointer f-flex-grow f-items-center f-w-1/1 f-min-h-4 f-min-w-4"
                        :class="{
                            [STATE_CLASSES.SELECTED]: isActiveIndex(index),
                        }"
                        v-bind="element"
                        :index="index"
                        :pointer="index + 1"
                        is-dynamic-element
                        @element-updated="elementUpdated"
                        @delete-element="deleteElement"
                        @click.native="onTabClick(index)"
                    >
                        <!-- eslint-disable-next-line vue/no-template-shadow -->
                        <template v-slot="{ elementUpdated, elementsNew }">
                            <div
                                class="f-flex f-flex-wrap f-bg-transparent f-h-1/1"
                            >
                                <drop-zone-output
                                    :elements-new="elementsNew"
                                    @element-updated="elementUpdated"
                                />

                                <drop-zone-input
                                    :elements-new="elementsNew"
                                    :top-level="true"
                                />
                            </div>
                        </template>
                    </tab-container>
                </template>
            </o-container>
            <o-container
                ref="panes"
                v-bind="element(2)"
                class-default="f-flex f-bg-transparent f-min-h-4 f-min-w-4"
                display-name="Tab Panes Container"
                @element-updated="elementUpdated"
            >
                <template v-slot="{ elementUpdated, elementsNew }">
                    <tab-pane-container
                        v-for="(element, index) in elementsNew"
                        v-show="isActiveIndex(index)"
                        :key="element.id"
                        v-group:tab-pane
                        is-dynamic-element
                        class-default="f-relative f-bg-transparent f-w-1/1 f-min-h-4 f-min-w-4"
                        :index="index"
                        :pointer="index + 1"
                        v-bind="element"
                        @element-updated="elementUpdated"
                    >
                        <!-- eslint-disable-next-line vue/no-template-shadow -->
                        <template v-slot="{ elementUpdated, elementsNew }">
                            <div class="f-flex f-flex-wrap f-bg-transparent">
                                <drop-zone-output
                                    :elements-new="elementsNew"
                                    @element-updated="elementUpdated"
                                />

                                <drop-zone-input
                                    :elements-new="elementsNew"
                                    :top-level="true"
                                />
                            </div>
                        </template>
                    </tab-pane-container>
                </template>
            </o-container>
        </div>
        <div
            :class="`f-relative ${hasMobileTransition ? 'f-hidden mob:f-block tab:f-block': 'f-hidden'} component__div f-h-1/1`"
        >
            <transition :name="!isOpenTab ? 'slidelclose' : 'slidelopen'">
                <o-container
                    v-show="!isOpenTab"
                    ref="tabs"
                    v-bind="element(1)"
                    style="display: block"
                    class-default="f-flex tabs__section f-items-center f-bg-transparent f-min-h-4 f-min-w-4"
                    display-name="Tabs Container"
                    @element-updated="elementUpdated"
                >
                    <template v-slot="{ elementUpdated, elementsNew }">
                        <tab-container
                            v-for="(element, index) in elementsNew"
                            :key="element.id"
                            v-group:tab-button
                            class-default="f-block f-z-1 f-items-center f-flex-grow f-bg-transparent f-cursor-pointer f-flex-grow f-items-center f-w-1/1 f-min-h-4 f-min-w-4"
                            v-bind="element"
                            :index="index"
                            :pointer="index + 1"
                            is-dynamic-element
                            @element-updated="elementUpdated"
                            @delete-element="deleteElement"
                            @click.native="onTabClick(index, elementsNew)"
                        >
                            <!-- eslint-disable-next-line vue/no-template-shadow -->
                            <template v-slot="{ elementUpdated, elementsNew }">
                                <div
                                    class="f-flex f-flex-wrap f-bg-transparent f-h-1/1 f-relative dynamic-nav-tab-go"
                                >
                                    <drop-zone-output
                                        :elements-new="elementsNew"
                                        @element-updated="elementUpdated"
                                    />

                                    <drop-zone-input
                                        :elements-new="elementsNew"
                                        :top-level="true"
                                    />
                                    <span class="right-chevron"><font-awesome-icon :icon="['fal', 'chevron-right']" /></span>
                                </div>
                            </template>
                        </tab-container>
                    </template>
                </o-container>
            </transition>
            <transition :name="isOpenTab ? 'sliderclose' : 'slideropen'">
                <o-container
                    v-show="isOpenTab"
                    ref="panes"
                    v-bind="element(2)"
                    class-default="f-flex f-bg-transparent f-min-h-4 f-min-w-4"
                    display-name="Tab Panes Container"
                    @element-updated="elementUpdated"
                >
                    <template v-slot="{ elementUpdated, elementsNew }">
                        <tab-pane-container
                            v-for="(element, index) in elementsNew"
                            v-show="isActiveIndex(index)"
                            :key="element.id"
                            v-group:tab-pane
                            is-dynamic-element
                            class-default="f-relative f-bg-transparent f-w-1/1 f-min-h-4 f-min-w-4"
                            :index="index"
                            :pointer="index + 1"
                            v-bind="element"
                            @element-updated="elementUpdated"
                        >
                            <!-- eslint-disable-next-line vue/no-template-shadow -->
                            <template v-slot="{ elementUpdated, elementsNew }">
                                <div v-show="isOpenTab" class="f-flex f-flex-wrap f-bg-transparent">
                                    <div
                                        class="f-items-center f-bg-bc-7 selected:f-bg-bc-1 f-cursor-pointer f-block tab:f-h-1/1 f-max-h-5 f-min-w-4 mob:f-min-w-14 tab:f-min-w-22 f-pr-0.5 lap:f-pr-0.25 f-relative f-w-1/1 f-z-1"
                                        :style="`
                                            background-image:
                                                linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)),
                                                url('https://seattlesymphony-dev-cm.flexaccelerator.com/-/media/images/homepage-hero/stripes-vertical-long.png?rev=fbc3ad835d6d458b9a38c40db421696c');
                                                background-size: auto;
                                                background-repeat: no-repeat;
                                                color: white;
                                                font-weight: 600;
                                            `"
                                        @click="closeTabContent()"
                                    >
                                        <div class="f-flex f-items-start tab:f-items-start lap:f-items-start f-flex-col f-flex-wrap f-h-1/1 tab:f-h-1/1 f-justify-center tab:f-justify-center lap:f-justify-center f-min-h-4 f-pl-2 f-relative f-w-1/1 f-z-1">
                                            <span v-html="openTabTitle" />
                                            <span class="dynamic-nav-tab-back">
                                                <font-awesome-icon :icon="['fal', 'chevron-left']" />
                                                <font-awesome-icon :icon="['fal', 'bars']" />
                                            </span>
                                        </div>
                                    </div>
                                    <drop-zone-output
                                        :elements-new="elementsNew"
                                        @element-updated="elementUpdated"
                                    />

                                    <drop-zone-input
                                        :elements-new="elementsNew"
                                        :top-level="true"
                                    />
                                </div>
                            </template>
                        </tab-pane-container>
                    </template>
                </o-container>
            </transition>
        </div>
    </flex-element>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import uuidv4 from 'uuid/v4';
import uniqid from 'uniqid';

import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import { Organism } from '@/data/data-models';
import {
    SHOW_SNACKBAR,
    CLEAR_SELECTED_ELEMENTS,
} from '@/store/types/mutation-types';
import flexDeepCopy from '@/utils/flex-deep-copy';
import { STATE_CLASSES } from '@/data/constants/classes';
import CollectionControls from '@/components/utilities/collection-controls';

const publicMode = process.env.VUE_APP_ENV === 'public';
const CUSTOM_ATTR_NAME = 'tabbed-nav-transition';

export default {
    name: 'advanced-tabbed-nav',
    components: { CollectionControls },
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Advanced Tabbed Nav',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            currentTabIndex: 0,
            openTabIndex: -1,
            openTabTitle: '',
            isOpenTab: false,
            itemId: uniqid(),
            STATE_CLASSES,
            tabDockLocation: 'left',
            hasMobileTransition: false,
        };
    },

    computed: {
        ...mapState({
            previewMode: state => state.previewMode,
        }),

        editingMode() {
            return !publicMode && !this.previewMode;
        },
    },

    async mounted() {
        await this.$nextTick();
        await this.$nextTick();
        if (this.tabElements().length === 0) {
            this.addTab(true);
        }
        this.hasMobileTransition = this.getElementData(CUSTOM_ATTR_NAME);
    },

    methods: {
        ...mapMutations({
            clearSelectedElements: CLEAR_SELECTED_ELEMENTS,
            showSnackbar: SHOW_SNACKBAR,
        }),

        tabElements() {
            return this.$refs.tabs.elementsNew || [];
        },

        paneElements() {
            return this.$refs.panes.elementsNew || [];
        },

        lastTabIndex() {
            return this.tabCount() - 1;
        },

        tabCount() {
            return this.$refs.tabs ? this.$refs.tabs.elementsNew.length : 0;
        },

        nextTabIndex() {
            return this.currentTabIndex < this.lastTabIndex()
                ? this.currentTabIndex + 1
                : 0;
        },

        previousTabIndex() {
            return this.currentTabIndex > 0
                ? this.currentTabIndex - 1
                : this.lastTabIndex();
        },

        deleteElement(index) {
            this.elementsNew.splice(index, 1);
            this.clearSelectedElements();
            this.setChangedData(true);
        },

        // this adds both a tab and tab pane simultaneously
        addTab(isMounted) {
            const pointer = this.tabElements().length + 1;
            let tabElement = null;
            let paneElement = null;

            if (this.tabElements().length && this.paneElements().length) {
                tabElement = { ...this.tabElements()[this.currentTabIndex] };
                tabElement.id = uuidv4();
                tabElement = flexDeepCopy(tabElement);
                tabElement.displayName = 'Dynamic Tab';

                paneElement = { ...this.paneElements()[this.currentTabIndex] };
                paneElement.id = uuidv4();
                paneElement = flexDeepCopy(paneElement);
                paneElement.displayName = 'Dynamic Pane';
            } else {
                tabElement = new Organism({
                    id: uuidv4(),
                    name: `tab-container_${pointer}`,
                    elementType: 'tab-container',
                    displayName: 'Dynamic Tab',
                    pointer,
                    classes: '',
                    templateType: 'Organism',
                    dataSourceId: '00000000-0000-0000-0000-000000000000',
                });

                paneElement = new Organism({
                    id: uuidv4(),
                    name: `tab-pane-container_${pointer}`,
                    elementType: 'tab-pane-container',
                    displayName: 'Dynamic Pane',
                    pointer,
                    classes: '',
                    templateType: 'Organism',
                    dataSourceId: '00000000-0000-0000-0000-000000000000',
                });
            }
            this.$refs.tabs.elementsNew.splice(
                this.currentTabIndex,
                0,
                tabElement,
            );
            this.$refs.panes.elementsNew.splice(
                this.currentTabIndex,
                0,
                paneElement,
            );
            this.onTabClick(this.nextTabIndex());
            if (!isMounted) {
                this.setChangedData(true);
            }
        },

        removeTab() {
            if (this.$refs.tabs.elementsNew.length > 0) {
                this.$refs.tabs.elementsNew.splice(this.currentTabIndex, 1);
                this.$refs.panes.elementsNew.splice(this.currentTabIndex, 1);

                if (
                    this.currentTabIndex !== 0
                    || this.$refs.tabs.elementsNew.length === 0
                ) {
                    this.onTabClick(this.previousTabIndex());
                }

                this.setChangedData(true);
            }
        },

        nextTab() {
            this.onTabClick(this.nextTabIndex());
            this.$root.$emit('flex::component::move');
        },

        previousTab() {
            this.onTabClick(this.previousTabIndex());
            this.$root.$emit('flex::component::move');
        },

        async incrementTab() {
            this.moveTab('down');
        },

        async decrementTab() {
            this.moveTab('up');
        },

        async moveTab(direction) {
            let to = this.currentTabIndex;
            to = direction === 'up'
                ? this.nextTabIndex()
                : this.previousTabIndex();

            this.moveElement(this.currentTabIndex, to, this.$refs.tabs);
            this.moveElement(this.currentTabIndex, to, this.$refs.panes);
            this.onTabClick(to);
            await this.$nextTick();
            this.$root.$emit('flex::component::move');
        },

        moveElement(index, to, elems) {
            const elem = elems.elementsNew[index];
            elems.elementsNew.splice(index, 1);
            elems.elementsNew.splice(to, 0, elem);
            elems.setChangedData(true);
        },

        onTabClick(clickedIndex, element) {
            if (element) { // Get title for mobile tab back
                const { richText, singleLineText } = element[clickedIndex].elements[0].elements[0];
                this.openTabTitle = richText === undefined ? singleLineText : richText;
            }
            if (clickedIndex === this.openTabIndex) {
                this.isOpenTab = false;
            } else {
                this.isOpenTab = true;
            }
            this.openTabIndex = clickedIndex;
            this.currentTabIndex = clickedIndex;
        },

        closeTabContent() {
            this.isOpenTab = false;
            this.openTabIndex = -1;
        },

        isActiveIndex(index) {
            return index === this.currentTabIndex;
        },
    },
};
</script>

<style lang="scss">
    .slidelopen-leave-active,
    .slidelopen-enter-active {
        position: absolute !important;
        transition: .5s;
    }
    .slidelopen-enter {
        transform: translate(100%, 0);
        position: absolute;
    }
    .slidelopen-leave-to {
        transform: translate(-100%, 0);
        position: absolute !important;
    }

    .slideropen-leave-active,
    .slideropen-enter-active {
        transition: .5s;
    }
    .slideropen-enter {
        transform: translate(100%, 0);
    }
    .slideropen-leave-to {
        transform: translate(-100%, 0);
    }

    .slidelclose-leave-active,
    .slidelclose-enter-active {
        position: absolute !important;
        transition: .5s;
    }
    .slidelclose-enter {
        transform: translate(-100%, 0);
        position: absolute;
    }
    .slidelclose-leave-to {
        transform: translate(100%, 0);
        position: absolute !important;
    }

    .sliderclose-leave-active,
    .sliderclose-enter-active {
        transition: .5s;
    }
    .sliderclose-enter {
        transform: translate(100%, 0);
    }
    .sliderclose-leave-to {
        transform: translate(-100%, 0);
    }

    .dynamic-nav-tab-back {
        position: absolute;
        right: 1rem;
        svg {
            &:first-child {
                margin-right: 5px;
            }
        }
    }
    .dynamic-nav-tab-go {
        span.right-chevron {
            color: white;
            display: none;
            position: absolute;
            right: 1rem;
            top: 1.3rem;
        }
        &:hover {
            span.right-chevron {
                display: inline-block;
            }
        }
    }
</style>
